import React, { useEffect } from "react";
import "./switchWithLabel.less";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import { IconButton, Tooltip } from "@material-ui/core";
import { InfoOutlined } from "@material-ui/icons";

export default function LabelWithSwitch({
  className = "toggleComponentContainer",
  tooltipTitle = "",
  labelHeading = "",
  selectedValue = false,
  keyValue = "",
  disabled = false,
  toolTip = "",
  onChange = () => {},
  changeClassForLabel = false,
  isConfirm=false

}) {
  const [checked, setState] = React.useState(selectedValue);

  useEffect(() => {
    setState(selectedValue);
  }, [selectedValue]);

  /**
   * call on onchange event of field
   * @param {*} event 
   */
  const handleChange = (event) => {
    if(isConfirm!=true){
    setState(event.target.checked);
    }
    onChange(keyValue, event.target.checked);
  };

  return (
    <div className={className}>
      {tooltipTitle && tooltipTitle.length > 0 ? (
        <Tooltip arrow title={tooltipTitle}>
          <FormControlLabel
            control={
              <Switch
                checked={checked}
                onChange={handleChange}
                name={"checked"}
                color={"primary"}
                disabled={disabled}
              />
            }
            label={
              <div>
                <span>{labelHeading}</span>
                {toolTip && (
                  <Tooltip title={toolTip}>
                    <IconButton
                      id={"iconBtn"}
                      size={"small"}
                      className={"tooltip-iconSize"}
                    >
                      <InfoOutlined fontSize={"inherit"} />
                    </IconButton>
                  </Tooltip>
                )}
              </div>
            }
          />
        </Tooltip>
      ) : (
        <FormControlLabel
          control={
            <Switch
              checked={checked}
              onChange={handleChange}
              name={"checked"}
              color={"primary"}
              disabled={disabled}
            />
          }
          label={
            <div>
              <span className={changeClassForLabel ? "switch-label-brr" : ""}>
                {labelHeading}
              </span>
              {toolTip && (
                <Tooltip title={toolTip}>
                  <IconButton
                    id={"iconBtn"}
                    size={"small"}
                    className={"tooltip-iconSize"}
                  >
                    <InfoOutlined fontSize={"inherit"} />
                  </IconButton>
                </Tooltip>
              )}
            </div>
          }
        />
      )}
    </div>
  );
}
